/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Admin_Indexnow_Key_File_BadInputs */

const en_admin_indexnow_key_file_bad = /** @type {(inputs: Admin_Indexnow_Key_File_BadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Not reachable yet (HTTP ${i?.status}). If you just saved, wait a minute and re-check.`)
};

/**
* | output |
* | --- |
* | "Not reachable yet (HTTP {status}). If you just saved, wait a minute and re-check." |
*
* @param {Admin_Indexnow_Key_File_BadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_key_file_bad = /** @type {((inputs: Admin_Indexnow_Key_File_BadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_Key_File_BadInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_key_file_bad(inputs)
});
export { admin_indexnow_key_file_bad as "admin.indexnow.key_file_bad" }